require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./aumnerie-1-1-14.json") })
        }
      }, "path---aumnerie-1-1-14");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---aumnerie-1-1-14!./.cache/json/aumnerie-1-1-14.json
// module id = 342
// module chunks = 231608221292675